import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui";
import { useTime } from "utils";

import {
  type AthleteProduct,
  getAthleteProductStatusLabel,
} from "src/helpers/athleteProductState";

import { AthleteProductBadge } from "./AthleteProductBadge";

interface AthleteProductTagProps {
  product: AthleteProduct;
}

export function AthleteProductTag(props: AthleteProductTagProps) {
  const { t } = useTranslation();
  const time = useTime();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <AthleteProductBadge product={props.product} />
      </TooltipTrigger>
      <TooltipContent>
        {getAthleteProductStatusLabel(t, time, props.product)}
      </TooltipContent>
    </Tooltip>
  );
}
